<template>
  <div v-if="!hasPermission('List Document Template')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar/>
    <div class="container-xxl">
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <div class="d-flex align-items-center position-relative my-1">
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                        transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                  <path
                      d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                      fill="black"></path>
                </svg>
              </span>
              <input type="text" v-model="search"
                     class="form-control form-control-solid w-250px ps-14"
                     placeholder="Pesquisar ...">
            </div>
          </div>
          <div class="card-toolbar">
            <div class="col-md-6" v-show="professionals.length > 1">
              <select class="form-select form-control-solid" aria-label="Selecionar Profissional"
                      v-model="currentProfessionalId" @change="loadTemplates($event.target.value)">
                <option value="" disabled selected v-if="professionals.length > 1">--Selecione--</option>
                <option :value="professional.id_prof" v-for="professional in professionals" :key="professional.id_prof">
                  {{ professional.prof_name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <button class="btn btn-flex btn-primary m-1"
                      title="Novo Modelo"
                      v-if="hasPermission('Store Document Template')"
                      @click="newTemplate">
                <i class="bi bi-plus-lg"></i> Adicionar
              </button>
            </div>
          </div>
        </div>

        <div class="card-body py-4">
          <table class="table table-row-bordered gy-5">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Modelo</th>
              <th style="text-align: center">Origem</th>
              <th style="text-align: center">IA</th>
              <th style="text-align: center">Ativo</th>
              <th style="text-align: center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="template in templatesFiltered" :key="template.id_doctempl">
              <td>{{ template.doctempl_name }}</td>
              <td style="text-align: center">
                <span class="badge badge-light-primary" v-if="template.doctempl_public">Sistema</span>
                <span class="badge badge-light-info" v-else-if="template.id_place && !template.id_prof">Local</span>
                <span class="badge badge-light-dark" v-else>Meu</span>
              </td>
              <td style="text-align: center">
                <span class="badge badge-light-info" v-if="template.doctempl_ai_fill">Sim</span>
                <span class="badge badge-light-secondary" v-else>Não</span>
              </td>
              <td style="text-align: center">
                <span class="badge badge-light-success" v-if="template.doctempl_active">Sim</span>
                <span class="badge badge-light-danger" v-else>Não</span>
              </td>
              <td style="text-align: center">
                <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        v-if="canEditTemplate(template)"
                        @click="editTemplate(template)"
                        title="Editar">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        v-else-if="hasPermission('List Document Template')"
                        @click="viewTemplate(template)"
                        title="Visualizar">
                  <i class="bi bi-eye"></i>
                </button>
                <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        v-if="canCloneTemplate(template)"
                        @click="cloneTemplate(template)"
                        title="Duplicar para editar">
                  <i class="bi bi-files"></i>
                </button>
                <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        v-if="canEditTemplate(template) && hasPermission('Delete Document Template')"
                        @click="deleteTemplate(template)"
                        title="Excluir Modelo">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!templatesFiltered.length">
              <td colspan="5" class="text-center text-muted py-5">
                Nenhum modelo de documento encontrado.
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <DocumentTemplateModal
        :template="selectedTemplate"
        :professional-id="currentProfessionalId"
        :readonly="modalReadonly"
        @saved="loadTemplates(currentProfessionalId)"
      />
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Permission from "../../helpers/permission";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import DocumentTemplateModal from "./DocumentTemplateModal.vue";
import Modal from "../../helpers/modal";

export default {
  name: "DocumentTemplates",
  components: {
    Toolbar,
    DocumentTemplateModal,
  },
  data() {
    return {
      search: '',
      currentProfessionalId: '',
      templates: [],
      selectedTemplate: null,
      modalReadonly: false,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
    templatesFiltered() {
      const term = this.search.toLowerCase();
      return this.templates.filter((template) =>
        (template.doctempl_name || '').toLowerCase().includes(term)
      );
    },
  },
  mounted() {
    if (this.professionals.length > 0) {
      this.currentProfessionalId = this.$store.state.auth.user.id_prof ?? this.professionals[0].id_prof;
      this.loadTemplates(this.currentProfessionalId);
    }
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    canEditTemplate(template) {
      return this.hasPermission('Update Document Template')
        && !template.doctempl_public
        && Number(template.id_prof) === Number(this.currentProfessionalId);
    },
    canCloneTemplate(template) {
      return this.hasPermission('Store Document Template')
        && (!!template.doctempl_public || (template.id_place && !template.id_prof));
    },
    loadTemplates(professionalId) {
      this.templates = [];
      this.currentProfessionalId = professionalId;
      if (!professionalId) {
        return;
      }

      http.get(`/professionals/${professionalId}/document-templates`, {
        params: {id_place: this.place?.id_place},
      }).then((response) => {
        this.templates = response.data;
      });
    },
    newTemplate() {
      this.selectedTemplate = null;
      this.modalReadonly = false;
      Modal.toggle('#documentTemplateModal');
    },
    editTemplate(template) {
      this.selectedTemplate = template;
      this.modalReadonly = false;
      Modal.toggle('#documentTemplateModal');
    },
    viewTemplate(template) {
      this.selectedTemplate = template;
      this.modalReadonly = true;
      Modal.toggle('#documentTemplateModal');
    },
    cloneTemplate(template) {
      this.selectedTemplate = {
        doctempl_name: `Cópia de ${template.doctempl_name}`,
        doctempl_body: template.doctempl_body,
        doctempl_active: true,
      };
      this.modalReadonly = false;
      Modal.toggle('#documentTemplateModal');
    },
    deleteTemplate(template) {
      Swal.fire({
        title: 'Heeyy',
        text: 'Tem certeza que deseja excluir este modelo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secundary',
        },
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        http.delete(`/professionals/${this.currentProfessionalId}/document-templates/${template.id_doctempl}`)
          .then(() => {
            Alert.toastSuccess('Modelo excluído com sucesso.');
            this.loadTemplates(this.currentProfessionalId);
          })
          .catch((e) => {
            Alert.toastError(e.response?.data?.message ?? e.response?.data);
          });
      });
    },
  },
};
</script>
